// Paleta de colores global para la aplicación
// Usada en CourseSelector, WeeklyCalendar y otros componentes

export const COURSE_COLORS = [
    '#C0392B', // Rojo
    '#E67E22', // Naranja
    '#F39C12', // Amarillo dorado
    '#229954', // Verde bosque
    '#1ABC9C', // Turquesa
    '#2980B9', // Azul medio
    '#0D47A1', // Azul oscuro
    '#8E44AD', // Púrpura
    '#6A1B9A', // Púrpura oscuro
    '#C2185B', // Rosa fuerte
    '#7B241C', // Vino
    '#922B21', // Borgoña
    '#784212', // Marrón oscuro
    '#95A5A6', // Gris claro
    '#00CED1', // Turquesa brillante
    '#FF6B35', // Coral
    '#FFD700', // Dorado
    '#FF1493', // Rosa neón
    '#1ABC9C'  // Aqua
];

// Importar el store centralizado de colores - VERSIÓN 11
import courseColorsStore from '@/store/courseColorsStore'

// Función para generar un color basado en un ID único
export function getRandomColor(uniqueId) {
  // Extraer courseId y subjectName del uniqueId
  const parts = uniqueId.toString().split('-')
  const courseId = parts[0]
  const subjectName = parts.slice(1).join('-') || ''
  
  // Usar el store centralizado para obtener el color
  return courseColorsStore.getCourseColor(courseId, subjectName)
}

// Función para generar hash (por si se necesita en otros lugares)
export function generateHash(str) {
  let hash = 0;
  const string = str.toString();
  
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convertir a entero de 32 bits
  }
  
  return hash;
}